module.exports = __webpack_public_path__ + "img/img_260515@2x.8f8c31c3.png";